import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiUrl, brands } from "../../config/config";

const RelatedProduct = ({ categoryId, categoryName }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const formattedName = categoryName
    ? categoryName.replace(/-/g, " ")
    : "Products";

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);

      try {
        const url = `${apiUrl}/api/${brands}/products/category/${categoryId}`;
        const res = await fetch(url);
        const data = await res.json();

        let productsList = [];

        if (Array.isArray(data)) {
          productsList = data;
        } else if (data.data && Array.isArray(data.data)) {
          productsList = data.data;
        }

        setProducts(productsList);
      } catch (err) {
        console.error("Product fetch error:", err);
        setProducts([]);
      }

      setLoading(false);
    };

    fetchProducts();
  }, [categoryId]);

  if (loading) {
    return (
      <div className="w-full bg-lightPastelPurple px-4 py-16">
        <p className="text-center text-base font-bold text-darkPurple">
          Loading products...
        </p>
      </div>
    );
  }

  if (products.length === 0) {
    return (
      <div className="w-full bg-lightPastelPurple px-4 py-16">
        <p className="text-center text-base font-bold text-[#5f5870]">
          No products found in this category.
        </p>
      </div>
    );
  }

  return (
    <div className="w-full bg-lightPastelPurple px-4 py-16">
      <div className="mx-auto max-w-7xl">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold leading-tight tracking-tight text-darkPurple md:text-4xl">
            Related Product
          </h2>

          <div className="mx-auto mt-4 flex w-full max-w-[230px] items-center justify-center gap-3">
            <span className="h-[1px] flex-1 bg-[#d8c8ff]"></span>
            <span className="h-2.5 w-2.5 rounded-full bg-keyLime shadow-[0_0_0_5px_rgba(215,255,79,0.25)]"></span>
            <span className="h-[1px] flex-1 bg-[#d8c8ff]"></span>
          </div>
        </div>

        {/* PRODUCT GRID */}
        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {products.map((item, index) => (
            <Link
              key={item.id}
              to={`/product/${
                item.category?.category_name?.replace(/\s+/g, "-") ||
                "category"
              }/${item.category_id}/${item.name?.replace(/\s+/g, "-")}/${
                item.id
              }`}
              className="group flex h-full flex-col overflow-hidden rounded-[26px] border border-pastelPurple bg-white p-4 shadow-[0_14px_35px_rgba(47,34,84,0.08)] transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_22px_50px_rgba(47,34,84,0.14)]"
              style={{
                animation: `fadeTop 0.55s ease both`,
                animationDelay: `${index * 90}ms`,
              }}
            >
              {/* IMAGE */}
              <div className="flex h-[185px] items-center justify-center rounded-[22px] bg-gradient-to-br from-[#f2ecff] via-white to-[#f8ffe0] p-4">
                <img
                  src={`${apiUrl}/storage/${item.image}`}
                  alt={item.name}
                  className="max-h-full max-w-full rounded-xl object-contain transition duration-500 group-hover:scale-105"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/placeholder-image.jpg";
                  }}
                />
              </div>
                  
              {/* TITLE */}
              <h3 className="mt-5 min-h-[52px] text-center text-base font-extrabold leading-6 text-darkPurple md:text-lg">
                {item.name}
              </h3>

              {/* PRICE */}
              <p className="mt-2 text-center text-sm font-bold text-themePurple">
                As low as{" "}
                <span className="font-extrabold text-[#5f7f00]">
                  ${item.discountedPrice}
                </span>
              </p>

             
            </Link>
          ))}
        </div>
      </div>

      <style>
        {`
          @keyframes fadeTop {
            from {
              opacity: 0;
              transform: translateY(-18px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
    </div>
  );
};

export default RelatedProduct;